import VueRecaptcha from 'vue-recaptcha';
import isEmail from '../utils/isEmail';

export default {
  name: 'about-contact-form',
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      company: '',
      message: '',
      validationStarted: false,
      formIsSending: false,
      formSent: false,
      backendError: '',
      recaptchaResponse: false,
    };
  },
  created() {},
  mounted() {},
  computed: {
    hasValidFirstname() {
      return this.firstname.length > 1;
    },
    hasValidLastname() {
      return this.lastname.length > 1;
    },
    hasValidPhone() {
      return this.phone.length > 9;
    },
    hasValidCompany() {
      return this.company.length > 0;
    },
    hasValidMessage() {
      return this.message.length > 4;
    },
    hasValidEmail() {
      return isEmail(this.email);
    },
    formIsValid() {
      return (
        this.hasValidFirstname &&
        this.hasValidLastname &&
        this.hasValidCompany &&
        this.hasValidMessage &&
        this.hasValidEmail &&
        this.recaptchaResponse
      );
    },
  },
  methods: {
    onVerify: function (response) {
      this.recaptchaResponse = response;
    },
    checkForm(e) {
      this.formIsSending = true;

      if (!this.validationStarted) this.validationStarted = true;

      if (!this.formIsValid) return (this.formIsSending = false);

      const {
        firstname,
        lastname,
        phone,
        company,
        message,
        email,
        recaptchaResponse,
      } = this;

      fetch('/contact-about', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
            .content,
        },
        body: JSON.stringify({
          firstname,
          lastname,
          company,
          phone,
          message,
          email,
          recaptchaResponse,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.formSent = true;
          this.formIsSending = false;
          window.location.href = data.redirect;
        })
        .catch((error) => {
          this.backendError = error;
          this.formIsSending = false;
        });
    },
  },
};
